import { render, staticRenderFns } from "./delDig.vue?vue&type=template&id=7a15e189"
import script from "./delDig.vue?vue&type=script&lang=js"
export * from "./delDig.vue?vue&type=script&lang=js"
import style0 from "./delDig.vue?vue&type=style&index=0&id=7a15e189&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports